import { Fade } from "@ui/components/feedback/fade/Fade";
import { Box } from "@ui/components/layout/box/Box";
import { Flex } from "@ui/components/layout/flex/Flex";
import { styles } from "./Wrapper.style";

import type { PropsWithChildren } from "react";
import type { Header } from "../../../../types";

type Props = {
    headers: Header;
    isSuccess: boolean;
    hasExtendedNewsletterForm: boolean;
} & PropsWithChildren;

export const Wrapper = ({ hasExtendedNewsletterForm, children, headers, isSuccess }: Props) => {
    const { description, header } = headers;
    return (
        <Flex {...styles.wrapper}>
            <Box {...styles.headerBox} data-testid="subscription-footer-header">
                <Fade in key="header">
                    <Box
                        {...styles.headerFadeBox}
                        w={hasExtendedNewsletterForm ? ["full", "45%"] : "unset"}
                    >
                        {header}
                    </Box>
                </Fade>
            </Box>
            <Box data-testid="subscription-footer-description">
                {!isSuccess && (
                    <Fade in key="description">
                        <Box {...styles.descriptionFadeBox}>{description}</Box>
                    </Fade>
                )}
            </Box>

            {children}
        </Flex>
    );
};
